import { render, staticRenderFns } from "./MainPageBottom.vue?vue&type=template&id=44220098&scoped=true&"
import script from "./MainPageBottom.vue?vue&type=script&lang=js&"
export * from "./MainPageBottom.vue?vue&type=script&lang=js&"
import style0 from "./MainPageBottom.vue?vue&type=style&index=0&id=44220098&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44220098",
  null
  
)

export default component.exports
import TouchPan from 'quasar/src/directives/TouchPan.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'directives', {TouchPan});
